import React from 'react';
import { Outlet } from 'react-router';

import { PageTopBar } from './components/page-top-bar';
import * as Styled from './life-area-detail.style';

export const LifeAreaDetail: React.FC = () => (
  <Styled.Container>
    <Styled.Main>
      <PageTopBar />

      <Outlet />
    </Styled.Main>
  </Styled.Container>
);
